import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { StockPositionDetailsFooterFragment } from './__generated__/StockPositionDetailsFooterFragment';
import { Footer } from 'components/PositionDetailsModal/components/Footer';
import { Factoid } from 'components/PositionDetailsModal/components/Footer/components/Factoid';

export interface Props {
  summary?: StockPositionDetailsFooterFragment;
}

export const PositionDetailFooter: React.FC<Props> = ({ summary }) => {
  const { t } = useTranslation();
  if (!summary) {
    return null;
  }

  const { netPnlAmount, buyAmount, sellAmount } = summary;

  return (
    <Footer>
      <Factoid title={t('Debited from the account')}>{buyAmount}</Factoid>
      <Factoid title={t('Withdrawn to account')}>{sellAmount}</Factoid>
      <Factoid title={t('Profit')}>{netPnlAmount}</Factoid>
    </Footer>
  );
};
